export default function getPageProperty(name) {
    let node = document.querySelector(`meta[name="${name}"]`)
    return node?.content
}

export function isSuperAdmin() {
    return getPageProperty('current-user-admin') === "true"
}